module.exports = __webpack_public_path__ + "8a9bdc69.jpg";